// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Wca-z","narrowOptionButtons":"Xca-z","noOptions":"Yca-z"};